export const TEXT = 'text'
export const NUMBER = 'number'
export const DATE = 'date'
export const GEOLOCATION = 'geolocation'
